import { Unit } from './units'

const SHEET_TSV_URL =
  'https://docs.google.com/spreadsheets/d/e/2PACX-1vTy-LZb1hwDwz6suvH86ytJPsYxZgk8i4GUOPlQ2bh-NRYMH1zAmCnqw2fvsbePZisR0do0659xy_HE/pub?output=tsv'

function parseNumber(value: string): number | null {
  if (!value || value.trim() === '' || value.trim() === '—') return null
  // Handle Czech decimal format (comma as decimal separator)
  const cleaned = value.trim().replace(',', '.')
  const num = parseFloat(cleaned)
  return isNaN(num) ? null : num
}

function parseStav(value: string): Unit['stav'] {
  const lower = (value || '').trim().toLowerCase()
  if (lower.includes('prodán') || lower.includes('prodano')) return 'prodáno'
  if (lower.includes('rezerv')) return 'rezervováno'
  return 'k dispozici'
}

function findColumnIndex(headers: string[], ...keywords: string[]): number {
  return headers.findIndex((h) => {
    const lower = h.toLowerCase().trim()
    return keywords.some((kw) => lower.includes(kw.toLowerCase()))
  })
}

export async function fetchUnitsFromSheet(): Promise<Unit[]> {
  const response = await fetch(SHEET_TSV_URL, { cache: 'no-store' })
  if (!response.ok) throw new Error(`Failed to fetch sheet: ${response.status}`)

  const text = await response.text()
  const lines = text.split('\n').filter((line) => line.trim() !== '')

  if (lines.length < 2) throw new Error('Sheet has no data rows')

  // Parse header row
  const headers = lines[0].split('\t').map((h) => h.trim())

  // Find column indices dynamically
  const colVchod = findColumnIndex(headers, 'vchod')
  const colPatro = findColumnIndex(headers, 'patro')
  const colKod = findColumnIndex(headers, 'kód jednotky', 'kod jednotky')
  const colTyp = findColumnIndex(headers, 'typ jednotky', 'typ')
  const colKategorie = findColumnIndex(headers, 'kategorie')
  const colPlocha = findColumnIndex(
    headers,
    'podlahová plocha',
    'podlahova plocha',
    'plocha m2 bytu',
  )
  const colCelkovaPlocha = findColumnIndex(
    headers,
    'celková plocha',
    'celkova plocha',
  )
  const colBalkon = findColumnIndex(headers, 'balkon')
  const colTerasa = findColumnIndex(headers, 'terasa')
  const colPredzahradka = findColumnIndex(
    headers,
    'předzahrádka',
    'predzahradka',
    'předzahr',
  )
  const colStav = findColumnIndex(headers, 'stav', 'status')

  const units: Unit[] = []

  for (let i = 1; i < lines.length; i++) {
    const cols = lines[i].split('\t').map((c) => c.trim())

    // Skip empty rows or rows without a unit code
    const kod = colKod >= 0 ? cols[colKod] : ''
    if (!kod || kod === '') continue

    const uzitnaPloch = colPlocha >= 0 ? parseNumber(cols[colPlocha]) : null
    if (uzitnaPloch === null) continue // Skip rows without area data

    const unit: Unit = {
      id: String(i),
      vchod: colVchod >= 0 ? cols[colVchod] || '' : '',
      patro: colPatro >= 0 ? cols[colPatro] || '' : '',
      kod: kod,
      typ: colTyp >= 0 ? cols[colTyp] || 'bytová jednotka' : 'bytová jednotka',
      kategorie: colKategorie >= 0 ? cols[colKategorie] || '' : '',
      uzitnaPlochM2: uzitnaPloch,
      balkonM2: colBalkon >= 0 ? parseNumber(cols[colBalkon]) : null,
      terasaM2: colTerasa >= 0 ? parseNumber(cols[colTerasa]) : null,
      predzahradkaM2:
        colPredzahradka >= 0 ? parseNumber(cols[colPredzahradka]) : null,
      stav: colStav >= 0 ? parseStav(cols[colStav]) : 'k dispozici',
    }

    units.push(unit)
  }

  return units
}
